var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view", attrs: { id: "verify-tree-grid" } },
    [
      _c("div", { staticClass: "main-content" }, [
        _c("div", { attrs: { slot: "operations" }, slot: "operations" }, [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  staticStyle: {
                    "margin-right": "10px",
                    "padding-top": "10px"
                  },
                  attrs: { "label-width": "100px", "label-position": "left" }
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.FileNo"),
                                prop: "fileNo"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "1" },
                                model: {
                                  value: _vm.query.fileNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "fileNo", $$v)
                                  },
                                  expression: "query.fileNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.BusinessNo"),
                                prop: "jobNo"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "2" },
                                model: {
                                  value: _vm.query.jobNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "jobNo", $$v)
                                  },
                                  expression: "query.jobNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.BookingAgent"),
                                prop: "bookingAgent"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "3",
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": { bookingAgent: true },
                                  "callback-method-type": "value",
                                  placeholder: " ",
                                  "default-value": _vm.query.bookingAgent || "",
                                  "callback-params": { key: "bookingAgent" }
                                },
                                on: { parentCallBack: _vm.setQuerySelectValue }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: this.$t("SeaExport.PortOfDestination"),
                                prop: "destinationPort"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                ref: "pod",
                                attrs: {
                                  no: "4",
                                  "select-type":
                                    _vm.query.portType === "AE"
                                      ? _vm.selectTypeNames.basic_data_Airport
                                      : _vm.selectTypeNames.basic_data_Seaport,
                                  filterable: "",
                                  placeholder: " ",
                                  "default-value": _vm.query.destinationPort,
                                  "tag-name": "englishName"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.query.destinationPort = p.code)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("Clearing.HouseWaybillNumber"),
                                prop: "jobHbl"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "5" },
                                model: {
                                  value: _vm.query.jobHbl,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "jobHbl", $$v)
                                  },
                                  expression: "query.jobHbl"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.SalesDepartment")
                              }
                            },
                            [
                              _c("cargo-department-select", {
                                attrs: {
                                  no: "salesDepartment",
                                  "office-id":
                                    _vm.$store.getters.currentOfficeId,
                                  "department-id": Number(_vm.query.salesDept)
                                },
                                on: {
                                  change: function(p) {
                                    _vm.query.salesDept = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.Customer"),
                                prop: "customerId"
                              }
                            },
                            [
                              _c("cargo-company-select", {
                                staticClass: "shipper-selector",
                                staticStyle: { flex: "1" },
                                attrs: {
                                  no: "8",
                                  "popper-class": "shipper-selector-popper",
                                  "method-params": { customer: true },
                                  "default-value": _vm.query.customerId || "",
                                  placeholder: " "
                                },
                                on: {
                                  change: function(p) {
                                    _vm.query.customerId = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.CustomsBroker"),
                                prop: "customsBroker"
                              }
                            },
                            [
                              _c("cargo-company-select", {
                                staticStyle: { width: "250px" },
                                attrs: {
                                  no: "9",
                                  "method-params": {
                                    customsBroker: true,
                                    active: true
                                  },
                                  "default-value":
                                    _vm.query.customsBroker || "",
                                  placeholder: " "
                                },
                                on: {
                                  change: function(p) {
                                    _vm.query.customsBroker = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.OperatingCompany"),
                                prop: "companyCName"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "10" },
                                model: {
                                  value: _vm.query.companyCName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "companyCName", $$v)
                                  },
                                  expression: "query.companyCName"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_TypeOfPort"),
                                prop: "portType"
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { no: "11" },
                                  model: {
                                    value: _vm.query.portType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.query, "portType", $$v)
                                    },
                                    expression: "query.portType"
                                  }
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          staticStyle: { float: "left" },
                                          attrs: { label: "SE" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_OceanFreight"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          staticStyle: { float: "left" },
                                          attrs: { label: "AE" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("CargoMsg.Cargo_Air"))
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.SoNo"),
                                prop: "soNo"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "12" },
                                model: {
                                  value: _vm.query.soNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "soNo", $$v)
                                  },
                                  expression: "query.soNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "6", type: "primary" },
                                  on: { click: _vm.queryHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Search"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "7", type: "primary" },
                                  on: { click: _vm.clearPage }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ResetFilter"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.BusinessType"),
                                prop: "jobLobs"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "13",
                                  "select-type":
                                    _vm.selectTypeNames
                                      .local_cache_SystemConstants$LOBS,
                                  filterable: "",
                                  placeholder: " ",
                                  "callback-method-type": "value",
                                  multiple: true,
                                  "default-multiple-value": _vm.query.jobLobs
                                },
                                on: {
                                  parentCallBack: function(value) {
                                    return (_vm.query.jobLobs = [].concat(
                                      value
                                    ))
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.Status"),
                                prop: "status"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "14",
                                  "select-type":
                                    _vm.selectTypeNames
                                      .local_cache_SystemConstants$FILE_STATUS3,
                                  filterable: "",
                                  placeholder: " ",
                                  "callback-method-type": "value",
                                  multiple: true,
                                  "default-multiple-value": _vm.query.status
                                },
                                on: {
                                  parentCallBack: function(value) {
                                    return (_vm.query.status = [].concat(value))
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.Vessel"),
                                prop: "vessel"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "15",
                                  filterable: "",
                                  clearable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Vessel,
                                  "tag-name": "englishName",
                                  "tag-value": "englishName",
                                  placeholder: " ",
                                  "default-value": _vm.query.vessel
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.query.vessel = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "padding-bottom": "5px",
                                "margin-right": "10px",
                                display: "flex"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { "min-width": "100px" },
                                  attrs: { no: "16" },
                                  on: { change: _vm.setQuerySelectValue },
                                  model: {
                                    value: _vm.query.timeType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.query, "timeType", $$v)
                                    },
                                    expression: "query.timeType"
                                  }
                                },
                                _vm._l(_vm.timeTypes, function(item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                }),
                                1
                              ),
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "17",
                                  type: "date",
                                  "value-format": "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.query.timeStart,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "timeStart", $$v)
                                  },
                                  expression: "query.timeStart"
                                }
                              }),
                              _c(
                                "span",
                                { staticStyle: { "padding-top": "5px" } },
                                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_To")))]
                              ),
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "18",
                                  type: "date",
                                  "value-format": "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.query.timeEnd,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "timeEnd", $$v)
                                  },
                                  expression: "query.timeEnd"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.ShippingCompany"),
                                prop: "jobCarrierId"
                              }
                            },
                            [
                              _c("cargo-company-select", {
                                attrs: {
                                  no: "19",
                                  placeholder: " ",
                                  "method-params": {
                                    seaCmp: true,
                                    active: true
                                  },
                                  "default-value": _vm.query.jobCarrierId || ""
                                },
                                on: {
                                  change: function(p) {
                                    _vm.query.jobCarrierId = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.FileType"),
                                prop: "fileTypes"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "20",
                                  filterable: "",
                                  multiple: true,
                                  placeholder: " ",
                                  "data-filter-function": _vm.dataFilterFunc,
                                  "callback-method-type": "value",
                                  "select-type":
                                    _vm.selectTypeNames
                                      .basic_data_TransmitFileType,
                                  "default-multiple-value": _vm.query.fileTypes,
                                  "tag-value": "name"
                                },
                                on: {
                                  parentCallBack: function(value) {
                                    return (_vm.query.fileTypes = [].concat(
                                      value
                                    ))
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.Mbl2"),
                                prop: "jobMbl"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "21" },
                                model: {
                                  value: _vm.query.jobMbl,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "jobMbl", $$v)
                                  },
                                  expression: "query.jobMbl"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.Voyage"),
                                prop: "voyageFlight"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "22" },
                                model: {
                                  value: _vm.query.voyageFlight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "voyageFlight", $$v)
                                  },
                                  expression: "query.voyageFlight"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.Operation"),
                                prop: "op"
                              }
                            },
                            [
                              _c("cargo-user-select", {
                                attrs: {
                                  no: "23",
                                  "method-params": {
                                    category: "role",
                                    shape: "op"
                                  },
                                  "default-value": _vm.query.op,
                                  placeholder: " "
                                },
                                on: {
                                  change: function(p) {
                                    _vm.query.op = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.Sales"),
                                prop: "sales"
                              }
                            },
                            [
                              _c("cargo-user-select", {
                                attrs: {
                                  no: "23",
                                  "method-params": {
                                    category: "role",
                                    shape: "sales"
                                  },
                                  "default-value": _vm.query.sales,
                                  placeholder: " "
                                },
                                on: {
                                  change: function(p) {
                                    _vm.query.sales = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticStyle: { display: "flex", height: "65%" } }, [
          _c(
            "div",
            {
              staticClass: "section",
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                width: "100%"
              }
            },
            [
              _c("cargo-ag-grid", {
                staticClass: "ag-theme-balham",
                staticStyle: { width: "100%", height: "60%" },
                attrs: {
                  "config-module": "950001",
                  "locale-text-func": _vm._i18nGridLocalText,
                  "grid-options": _vm.businessList.gridOptions,
                  "column-defs": _vm.businessList.columnDefs,
                  "row-data": _vm.businessList.rowData,
                  "grid-params": _vm.businessList.gridParams
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.businessList, "gridParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.businessList, "gridParams", $event)
                  },
                  gridReady: _vm.onGridReady
                }
              }),
              _c(
                "div",
                { staticClass: "pagination-wrapper" },
                [
                  _c("cargo-pagination", {
                    attrs: {
                      "config-module": "9500003",
                      total: _vm.businessList.total,
                      page: _vm.businessList.filter.pageNum,
                      limit: _vm.businessList.filter.pageSize
                    },
                    on: {
                      "update:page": function($event) {
                        return _vm.$set(
                          _vm.businessList.filter,
                          "pageNum",
                          $event
                        )
                      },
                      "update:limit": function($event) {
                        return _vm.$set(
                          _vm.businessList.filter,
                          "pageSize",
                          $event
                        )
                      },
                      pagination: _vm.toQueryByPage
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "section" }, [
          _c(
            "div",
            [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_CRFileBack_file"
                          ]),
                          expression:
                            "$checkPermission(['button_CRFileBack_file'])"
                        }
                      ],
                      attrs: {
                        no: "24",
                        disabled: !_vm.opButton.batchBackBtn,
                        type: "primary"
                      },
                      on: { click: _vm.onBack }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Back")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_CRFileBack_file"
                          ]),
                          expression:
                            "$checkPermission(['button_CRFileBack_file'])"
                        }
                      ],
                      attrs: {
                        no: "25",
                        disabled: !_vm.opButton.batchCancelBackBtn,
                        type: "primary"
                      },
                      on: { click: _vm.onCancelBack }
                    },
                    [_vm._v(_vm._s(_vm.$t("Clearing.RevokeFetch")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: !_vm.opButton.secondSend,
                        type: "primary"
                      },
                      on: { click: _vm.secondSendHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_2NdDispatch")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "26",
                        disabled: !_vm.opButton.editBtn,
                        type: "primary"
                      },
                      on: { click: _vm.editRemarkHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_EditRemarks")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "27",
                        disabled: !_vm.opButton.delBtn,
                        type: "primary"
                      },
                      on: { click: _vm.deleteHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "28",
                        disabled: !_vm.opButton.batchPrintBtn,
                        type: "primary"
                      },
                      on: { click: _vm.onPrint }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PrintList")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "29",
                        disabled: !_vm.opButton.batchSendBtn,
                        type: "primary"
                      },
                      on: { click: _vm.onSend }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Send2")))]
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  staticStyle: { "padding-top": "5px" },
                  attrs: {
                    inline: true,
                    "label-width": "65px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: this.$t("SeaExport.OperatingCompany") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "30", readonly: true, disabled: true },
                        model: {
                          value: _vm.businessList.selectedData.companyCName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.businessList.selectedData,
                              "companyCName",
                              $$v
                            )
                          },
                          expression: "businessList.selectedData.companyCName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: {
                        label: this.$t("CargoMsg.Cargo_VesselAndVoyage")
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: {
                          no: "31",
                          value: _vm.vesselAndVoyage(),
                          readonly: true,
                          disabled: true
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: this.$t("SeaExport.DepartureTime") }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "160px" },
                        attrs: {
                          no: "32",
                          readonly: true,
                          disabled: true,
                          type: "date",
                          clearable: "",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.businessList.selectedData.etd,
                          callback: function($$v) {
                            _vm.$set(_vm.businessList.selectedData, "etd", $$v)
                          },
                          expression: "businessList.selectedData.etd"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.TenBitCode") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "33", readonly: true, disabled: true },
                        model: {
                          value: _vm.businessList.selectedData.tenDigitCode,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.businessList.selectedData,
                              "tenDigitCode",
                              $$v
                            )
                          },
                          expression: "businessList.selectedData.tenDigitCode"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  staticStyle: { "padding-top": "5px" },
                  attrs: {
                    inline: true,
                    "label-width": "65px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: this.$t("SeaExport.Customer") }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "34",
                          readonly: true,
                          "custom-style": "width:160px",
                          disabled: true,
                          placeholder: " ",
                          "popper-class": "shipper-selector-popper",
                          "method-params": { customer: true },
                          "default-value":
                            _vm.businessList.selectedData.customerId || ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "custom", attrs: { label: "MBL" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "35", readonly: true, disabled: true },
                        model: {
                          value: _vm.businessList.selectedData.mbl,
                          callback: function($$v) {
                            _vm.$set(_vm.businessList.selectedData, "mbl", $$v)
                          },
                          expression: "businessList.selectedData.mbl"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: this.$t("SeaExport.Operation") }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "160px" },
                        attrs: {
                          no: "36",
                          readonly: true,
                          disabled: true,
                          filterable: "",
                          placeholder: " ",
                          "select-type": _vm.selectTypeNames.basic_data_User,
                          "callback-method-type": "value",
                          "default-value":
                            _vm.businessList.selectedData.op === 0
                              ? ""
                              : _vm.businessList.selectedData.op,
                          "callback-params": { key: "op" }
                        },
                        on: { parentCallBack: _vm.setQuerySelectValue }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: this.$t("SeaExport.CustomsBroker") }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "37",
                          disabled: true,
                          placeholder: " ",
                          "method-params": {
                            customsBroker: true,
                            seaExport: true,
                            active: true
                          },
                          "default-value":
                            _vm.businessList.selectedData.customsBroker || "",
                          "custom-style": "width:160px;"
                        },
                        on: {
                          change: function(p) {
                            _vm.businessList.selectedData.customsBroker =
                              p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "65px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Remarks") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "1000px" },
                        attrs: {
                          no: "38",
                          type: "textarea",
                          rows: 3,
                          readonly: true,
                          disabled: true
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.Remarks"),
                              _vm.businessList.selectedData.remark,
                              function(val) {
                                _vm.businessList.selectedData.remark = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.businessList.selectedData.remark,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.businessList.selectedData,
                              "remark",
                              $$v
                            )
                          },
                          expression: "businessList.selectedData.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("el-input", {
            attrs: { type: "textarea", rows: "10", no: "39" },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { attrs: { type: "primary", no: "40" } }, [
                _vm._v(_vm._s(_vm.$t("common.btn.confirm")))
              ]),
              _c(
                "el-button",
                {
                  attrs: { no: "41" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("dc-send-out-window", {
        ref: "dcSendOut",
        attrs: {
          "send-out-dialog": _vm.sendOutDialog,
          visible: _vm.sendOutDialog.visible,
          job: _vm.job,
          "selected-files": _vm.selectedFiles
        },
        on: {
          dcSendOutVisible: function($event) {
            _vm.sendOutDialog.visible = false
          },
          successHandler: _vm.backSuccessHandler
        }
      }),
      _c("file-dialog", {
        ref: "fileDialog",
        attrs: {
          visible: _vm.editDialog.visible,
          "is-remark-only": _vm.editDialog.isRemarkOnly,
          "selected-file": _vm.businessList.selectedData,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.editDialog, "visible", $event)
          },
          successHandler: _vm.successHandler,
          backSuccessHandler: _vm.backSuccessHandler
        }
      }),
      _c("dc-take-back-window", {
        ref: "dcTakeBack",
        attrs: {
          "take-back-dialog": _vm.takeBackDialog,
          visible: _vm.takeBackDialog.visible,
          job: _vm.job,
          "selected-files": _vm.selectedFiles
        },
        on: { successHandler: _vm.backSuccessHandler }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }